module.exports = __webpack_public_path__ + "static/media/calculator-alt.ecd0550c.svg";